import { registerPlugin } from '../utils.js'
import { VariablesProgrammatic } from '../../../variables/index'

const Variables = {
  init: function (editor) {
    editor.addCommand('insertVariable', {
      exec: function (editor) {
        VariablesProgrammatic.open({
          insert: (i) => editor.insertHtml(i),
        })
      },
    })
    editor.ui.addButton('AKVariables', {
      label: 'Insert Tag',
      command: 'insertVariable',
      toolbar: 'insert',
    })
  },
}

const Plugin = {
  install() {
    registerPlugin('akvariables', Variables)
  },
}

export default Plugin
